
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 5655"}},[_c('g',{attrs:{"data-name":"Group 5654"}},[_c('path',{attrs:{"data-name":"Path 173","d":"M47.09 19.14L35.16 56.91 64 19.14z"}})])]),_c('g',{attrs:{"data-name":"Group 5657"}},[_c('g',{attrs:{"data-name":"Group 5656"}},[_c('path',{attrs:{"data-name":"Path 174","d":"M9.29 5.79l-9.15 11H15.7z"}})])]),_c('g',{attrs:{"data-name":"Group 5659"}},[_c('g',{attrs:{"data-name":"Group 5658"}},[_c('path',{attrs:{"data-name":"Path 175","d":"M54.7 5.79l-6.41 11h15.57z"}})])]),_c('g',{attrs:{"data-name":"Group 5661"}},[_c('g',{attrs:{"data-name":"Group 5660"}},[_c('path',{attrs:{"data-name":"Path 176","d":"M16.89 19.14H0l28.84 37.77z"}})])]),_c('g',{attrs:{"data-name":"Group 5663"}},[_c('g',{attrs:{"data-name":"Group 5662"}},[_c('path',{attrs:{"data-name":"Path 177","d":"M34.86 4.92L46 16l6.46-11.08z"}})])]),_c('g',{attrs:{"data-name":"Group 5665"}},[_c('g',{attrs:{"data-name":"Group 5664"}},[_c('path',{attrs:{"data-name":"Path 178","d":"M11.53 4.92L18 16 29.13 4.92z"}})])]),_c('g',{attrs:{"data-name":"Group 5667"}},[_c('g',{attrs:{"data-name":"Group 5666"}},[_c('path',{attrs:{"data-name":"Path 179","d":"M19.38 19.14L32 59.08l12.61-39.94z"}})])]),_c('g',{attrs:{"data-name":"Group 5669"}},[_c('g',{attrs:{"data-name":"Group 5668"}},[_c('path',{attrs:{"data-name":"Path 180","d":"M32 5.41L20.63 16.78h22.73z"}})])])])
          )
        }
      }
    